import { APP_CHART_COLORS } from './colors';

/** Opaque, high-contrast palette for multi-segment ESG charts. */
export const ESG_BLUE_PALETTE = [...APP_CHART_COLORS];
